"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usageLinkWithParams = void 0;
var date_fns_1 = require("date-fns");
var usageLinkWithParams = function (params) {
    if (!params) {
        return "/usage";
    }
    var generatedUrl = '/usage?';
    Object.keys(params).map(function (key, index) {
        var paramKey = index == 0 ? key + '=' : '&' + key + '=';
        var paramValue = params.date && key === 'date'
            ? (0, date_fns_1.format)(params['date'], 'yyyy-MM-dd')
            : params[key];
        generatedUrl += paramKey + paramValue;
    });
    return generatedUrl;
};
exports.usageLinkWithParams = usageLinkWithParams;
